<template>
  <div class="sheetSetLeft">
    <!-- 操作按钮 -->
    <div class="leftButtons">
      <el-button type="primary" size="small" plain @click="addSheetSetCatalog">新增</el-button>
      <el-button type="primary" size="small" plain @click="renameSheetSetCatalog">编辑</el-button>
      <el-button type="danger" size="small" plain @click="deleteSheetSetCatalog">删除</el-button>
      <el-button type="primary" size="small" plain @click="copySheetSetCatalog">复制</el-button>
      <el-button type="primary" size="small" plain @click="copyToSheetSetCatalog">复制到</el-button>
      <el-button v-if="!expandAll" type="primary" size="small" plain @click="expandSheetSetCatalog">展开</el-button>
      <el-button v-if="expandAll" type="primary" size="small" plain @click="expandSheetSetCatalog">收起</el-button>
    </div>
    <!-- 目录树 -->
    <div class="treeArea">
      <el-tree ref="tree" :props="defaultProps" :accordion="false" :render-content="renderContent"
        :default-expanded-keys="unfoldIdArr" highlight-current node-key="folderId" :data="treeData"
        @node-expand="treeExpand" @node-collapse="treeCollapse" @node-click="clickNodeTree">
      </el-tree>
    </div>
    <sheetSet-copy v-if="sheetSetCopyShow" :folder-data="folderData"></sheetSet-copy>
    <el-dialog v-dialogDrag :visible.sync="addSheetSetOpen" :title="sheetSetNameTitle" width="27%" top="25vh"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 新文件名称 -->
      <el-form ref="sheetSetForm" :model="sheetSetForm" label-position="top" label-width="80px" :rules="rules" size="small">
        <el-form-item label="请输入图纸集名称" prop="sheetSetName">
          <el-input ref="sheetSetName" v-model.trim="sheetSetForm.sheetSetName" placeholder="请输入图纸集名称" size="small" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addSheetSetOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addSheetSetDetermine">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sheetSetService from "@/CommonDP/service/sheetSet-service";
import { sheetSetLeftTreeIcon } from "@/CommonDP/utils/docPublic";
import { mapState } from "vuex";
import sheetSetCopy from "../component/sheetSetCopy.vue";
export default {
  components: {
    sheetSetCopy
  },
  data() {
    var sheetSetNameV = (rule, value, callback) => {
      const regExp = new RegExp('[\\\\|/:*<>?"]');
      if (value === "") {
        callback(new Error("请输入图纸集名称"));
      } else if (value.length > 50) {
        callback(new Error("图纸集名称不能大于50个字符"));
      } else if (regExp.test(value)) {
        callback(new Error('图纸集名称不能包含以下字符:\\ / : * " ? < > |'));
      } else {
        callback();
      }
    };
    return {
      defaultProps: {
        children: "childList",
        label: "folderName"
      },
      folderData: {},
      sheetSetCopyShow: false,
      expandAll: false,
      treeData: [],
      unfoldIdArr: [],
      addSheetSetOpen: false,
      sheetSetNameTitle: "新增图纸集",
      sheetSetForm: {
        sheetSetName: ""
      },
      rules: {
        sheetSetName: [{ required: true, trigger: "blur", validator: sheetSetNameV }]
      }
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  created() {
    this.queryTreeData();
  },
  mounted() {},
  methods: {
    async queryTreeData(data) {
      const resArr = await sheetSetService.prjDrawingSetList(this.prjInfo.prjId);
      this.treeData = resArr.data;
      if (!data) {
        this.folderData = resArr.data[0];
      }
      this.$store.dispatch("setFolderData", this.folderData);
      if (this.folderData.folderId) {
        this.$nextTick(() => {
          if (this.$refs.tree) {
            this.$refs.tree.setCurrentKey(this.folderData.folderId);
          }
        });
      }
    },
    // 新增图纸集目录树
    addSheetSetCatalog() {
      if (this.folderData.folderId && this.folderData.folderNew === 1 && this.folderData.folderType === 51) {
        this.addSheetSetOpen = true;
        this.sheetSetForm.sheetSetName = "";
        this.sheetSetNameTitle = "新增图纸集";
        this.$nextTick(() => {
          this.$refs.sheetSetName.focus();
          this.$refs.sheetSetForm.resetFields();
        });
      } else {
        this.$message.warning("请点击【图纸集】新增自定义图纸集");
      }
    },
    async addSheetSetDetermine() {
      this.$refs.sheetSetForm.validate(async (valid) => {
        if (valid) {
          const parentId = this.folderData.folderId;
          const listName = this.sheetSetForm.sheetSetName;
          if (this.sheetSetNameTitle === "新增图纸集") {
            const data = { parentId, listName };
            await sheetSetService.prjDrawingSetAdd(data);
            this.$message.success("新建成功");
          } else {
            const listId = this.folderData.folderId;
            const data = { parentId, listName, listId };
            await sheetSetService.prjDrawingSetRename(data);
            this.$message.success("编辑成功");
            this.$emit("toQueryList");
          }
          this.addSheetSetOpen = false;
          this.queryTreeData(1);
        } else {
          return false;
        }
      });
    },
    // 树前面的图标
    renderContent(h, { node, data, store }) {
      return h("div", { style: "display:flex;align-items:center;width:100%;overflow: hidden;padding-right:25px" }, [
        h("img", {
          attrs: {
            src: sheetSetLeftTreeIcon(node.data)
          },
          style: "margin-right:6px;-webkit-user-drag: none;-moz-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none;"
        }),
        h("div", {
          domProps: {
            innerText: node.label
          },
          attrs: {
            class: "ellipsis",
            title: node.label
          }
        })
      ]);
    },
    // 点击树级
    clickNodeTree(data, node, resolve) {
      // 没有子级
      if (data.folderType === 52 || data.folderType === 51) {
        this.folderData = data;
        this.$store.dispatch("setFolderData", this.folderData);
        this.getTreeNode(node);
      }
    },
    // 编辑
    async renameSheetSetCatalog() {
      if (this.folderData.folderId && this.folderData.isSys === 0 && this.folderData.folderType === 52) {
        this.addSheetSetOpen = true;
        this.sheetSetNameTitle = "编辑图纸集";
        this.$nextTick(() => {
          this.$refs.sheetSetForm.resetFields();
        });
        const res = await sheetSetService.prjDrawingSetGetByListId(this.folderData.folderId);
        this.sheetSetForm.sheetSetName = res.data.listName;
      } else {
        this.$message.warning("请选择【自定义图纸集】进行编辑");
      }
    },
    // 删除
    async deleteSheetSetCatalog() {
      if (this.folderData.folderId && this.folderData.isSys === 0 && this.folderData.folderType === 52) {
        this.$confirm("您是否确定删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            await sheetSetService.prjDrawingSetDelete(this.folderData.folderId);
            this.$store.dispatch("setIsMajor", {});
            this.$message.success("删除成功");
            await this.queryTreeData();
          })
          .catch(() => {});
      } else {
        this.$message.warning("请选择【自定义图纸集】进行删除");
      }
    },
    // 复制
    async copySheetSetCatalog() {
      if (this.folderData.folderId && this.folderData.folderType === 52) {
        await sheetSetService.prjDrawingSetCopy(this.folderData.folderId, "");
        this.queryTreeData(1);
        this.$message.success("复制成功");
      } else {
        this.$message.warning("请选择【图纸集】的子级");
      }
    },
    // 复制到
    copyToSheetSetCatalog() {
      if (this.folderData.folderId && this.folderData.folderType === 52) {
        this.sheetSetCopyShow = true;
      } else {
        this.$message.warning("请选择【图纸集】的子级");
      }
    },
    // 展开 收起 1
    expandSheetSetCatalog() {
      this.expandAll = !this.expandAll;
      this.changeTreeNodeStatus(this.$refs.tree.store.root);
    },
    // 展开 收起 2
    changeTreeNodeStatus(node) {
      node.expanded = this.expandAll;
      for (let i = 0; i < node.childNodes.length; i++) {
        node.childNodes[i].expanded = this.expandAll;
        if (node.childNodes[i].childNodes.length > 0) {
          this.changeTreeNodeStatus(node.childNodes[i]);
        }
      }
    },
    // 单个树展开
    treeExpand(data, node) {
      node.isExpand = true;
      this.folderData = data;
      this.$store.dispatch("setFolderData", this.folderData);
      this.unfoldIdArr.push(data.folderId);
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey(data.folderId);
        }
      });
    },
    // 单个树收起
    treeCollapse(data, node) {
      node.isExpand = false;
      this.folderData = data;
      this.$store.dispatch("setFolderData", this.folderData);
      for (let i = 0; i < this.unfoldIdArr.length; i++) {
        if (this.unfoldIdArr[i] === data.folderId) {
          this.unfoldIdArr.splice(i, 1);
        }
      }
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.$refs.tree.setCurrentKey(data.folderId);
        }
      });
    },
    getTreeNode(node) {
      if (node.label !== undefined) {
        if (node.data.folderType !== 11) {
          this.getTreeNode(node.parent); // 递归
        } else {
          this.$store.dispatch("setIsMajor", node.data);
          this.$emit("toSetIsMajor");
        }
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.sheetSetLeft {
  width: 100%;
  height: 100%;

  .leftButtons {
    width: 100%;
    padding: 12px 5%;

    display: flex;
    justify-content: space-between;

    .el-button {
      width: 15%;
      padding: 8px 4px !important;
      margin: 0 !important;
    }
  }

  .treeArea {
    width: 100%;
    height: calc(100% - 55px);
    padding: 0 5%;
    overflow-y: auto;
  }
}
</style>
